/**
 * @file wms-document-meta.ts
 * @description Сборка плиток «кто / когда / итоги» для складских документов
 * (phase19.23 этап A).
 *
 * Один источник правды для приёмки и списания (дальше — перемещения и
 * инвентаризации): читатель документа всегда находит автора и дату проведения
 * на одном и том же месте, а формат даты не расходится по экранам.
 */

import type { DocumentMetaItem } from "../ui/DocumentMetaGrid";
import { formatDocTotals } from "../../lib/wms-doc-totals";

/** Дата документа: «01.09 10:12» — день и время, год в шапке не нужен. */
export function formatDocDateTime(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

interface DocMetaInput {
  /** Подпись первой плитки: «Создал», «Принял». */
  authorLabel: string;
  author?: string | null;
  createdAt: string;
  committedAt?: string | null;
  /** Строки документа — из них считаются итоги. */
  items?: readonly { quantity: string }[] | null;
}

/** Четыре плитки документа: автор, создано, проведено, итого. */
export function buildDocumentMeta({
  authorLabel,
  author,
  createdAt,
  committedAt,
  items,
}: DocMetaInput): DocumentMetaItem[] {
  return [
    { label: authorLabel, value: author ?? "—" },
    { label: "Создано", value: formatDocDateTime(createdAt), mono: true },
    {
      label: "Проведено",
      value: committedAt ? formatDocDateTime(committedAt) : "не проведено",
      mono: !!committedAt,
      tone: committedAt ? "success" : "warning",
    },
    { label: "Итого", value: formatDocTotals(items), mono: true },
  ];
}
